var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.33317 14.6663C2.94359 14.6663 2.61008 14.5276 2.33265 14.2502C2.05522 13.9728 1.9165 13.6393 1.9165 13.2497V4.74967C1.9165 4.36009 2.05522 4.02658 2.33265 3.74915C2.61008 3.47172 2.94359 3.33301 3.33317 3.33301H6.87484V4.74967H3.33317V13.2497H14.6665V4.74967H11.1248V3.33301H14.6665C15.0561 3.33301 15.3896 3.47172 15.667 3.74915C15.9445 4.02658 16.0832 4.36009 16.0832 4.74967V13.2497C16.0832 13.6393 15.9445 13.9728 15.667 14.2502C15.3896 14.5276 15.0561 14.6663 14.6665 14.6663H3.33317ZM8.99984 11.408L5.45817 7.86634L6.44984 6.87467L8.2915 8.71634V3.33301H9.70817V8.71634L11.5498 6.87467L12.5415 7.86634L8.99984 11.408Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.26d12d4de973c8408b197b9c0b83b873.svg";
export { ForwardRef as ReactComponent };